import React, { memo, ReactNode, useState } from 'react';

import { areEqual } from 'Utils/equalityChecks';
import { width } from 'Utils/screen';
import { MiniTab } from 'Components/Tabs/MiniTab';

import classes from './clockInOutTabs.tabs.module.css';

interface Props {
  id?: string;
  className?: string;
  children?: ReactNode;
}

const createTabs = (activeTab: string, onTabClick: (e: any) => void) => (
  <>
    <MiniTab
      key="timecard-tab"
      id="timecard-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'timecard-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="timecard"
      onClick={onTabClick}
    >
      <>
        <span>Timecard</span>
      </>
    </MiniTab>
    <MiniTab
      key="overview-tab"
      id="overview-tab"
      className={`${classes.flexCenter} ${classes.button} ${
        activeTab === 'overview-tab' ? `active ${classes['active-Tab']}` : ''
      }`}
      target="overview"
      onClick={onTabClick}
    >
      <>
        <span>Overview</span>
      </>
    </MiniTab>
  </>
);

/*
  In order to override bootstraps active class on tabs, there is a click event onTabClick, which will get the name of the tab that was clicked
  and then trigger a re-render.  Note in the createTabs method above, where the active class is added or not, based on which tab was clicked.
*/
const ClockInOutTabs = ({ id = 'tabs', className, children }: Props) => {
  // We want to set the initial active tab to the first tab in the incoming tabList
  const [activeTab, setActiveTab] = useState('timecard-tab');

  const onTabClick = (e: any) => {
    // Occasionally, e.currentTarget is undefined.  Set the current activeTab if we run into this bug

    setActiveTab(e?.currentTarget?.id || activeTab);
  };

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col">
          <div className={classes.clockInOutTabWrapper}>
            <div className={classes.tabsContainer}>
              <ul
                className={`nav nav-tabs pr-4 ${width < 576 ? 'flex-sm-column' : 'width'}   ${classes.tabs} ${
                  className || ''
                }`}
                id={id}
                role="tablist"
              >
                {createTabs(activeTab, onTabClick)}
              </ul>
            </div>
            <div className="tab-content w-100 h-100 d-inline-block" id="myTabContent" style={{ height: 'auto' }}>
              {children}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

ClockInOutTabs.defaultProps = {
  id: undefined,
  className: undefined,
  children: undefined,
};

const ClockInOutTabsMemo = memo(ClockInOutTabs, areEqual);
export { ClockInOutTabsMemo as ClockInOutTabs };
